import {createRouter, createWebHistory} from "vue-router/dist/vue-router";
import {routes} from "../router";
import {useStore} from "../store";
import {getAuthToken} from "../services/baseService";

const router = createRouter({
    mode: 'history',
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        const store = useStore();
        const token = store.accessToken || getAuthToken();
        const isAuthenticated = store.userRole != null && !!token;

        if (isAuthenticated) {
            if (store.forceTo != null && to.name !== store.forceTo) {
                next({name: store.forceTo});
            } else {
                next();
            }
        } else {
            if (store.clearUser) {
                store.clearUser();
            }
            next({name: "SignIn", query: { redirect: to.fullPath }});
        }
    } else {
        next();
    }
});

export default router;
